/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorPollSettings', 'model/PerformanceIndicatorPollSettingsLightReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorPollSettings'), require('../model/PerformanceIndicatorPollSettingsLightReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorPollSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorPollSettings, root.ForStractionServiceApi.PerformanceIndicatorPollSettingsLightReport);
  }
}(this, function(ApiClient, PerformanceIndicatorPollSettings, PerformanceIndicatorPollSettingsLightReport) {
  'use strict';

  /**
   * PerformanceIndicatorPollSettings service.
   * @module api/PerformanceIndicatorPollSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorPollSettingsApi. 
   * @alias module:api/PerformanceIndicatorPollSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorPollSettingsAddMoodIndexPollGet operation.
     * @callback module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsAddMoodIndexPollGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addMoodIndexPoll
     * @param {String} _4SAPIAppID 
     * @param {module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsAddMoodIndexPollGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.performanceIndicatorPollSettingsAddMoodIndexPollGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollSettingsAddMoodIndexPollGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollSettings/addMoodIndexPoll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollSettingsAddPut operation.
     * @callback module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceIndicatorPollSettings} body 
     * @param {module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.performanceIndicatorPollSettingsAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollSettingsAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorPollSettingsAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollSettings/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollSettingsClearCurrentPollPeriodAndSendGet operation.
     * @callback module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsClearCurrentPollPeriodAndSendGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clearCurrentPollPeriodAndSend
     * @param {String} _4SAPIAppID 
     * @param {Integer} settingID 
     * @param {module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsClearCurrentPollPeriodAndSendGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorPollSettingsClearCurrentPollPeriodAndSendGet = function(_4SAPIAppID, settingID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollSettingsClearCurrentPollPeriodAndSendGet";
      }

      // verify the required parameter 'settingID' is set
      if (settingID == undefined || settingID == null) {
        throw "Missing the required parameter 'settingID' when calling performanceIndicatorPollSettingsClearCurrentPollPeriodAndSendGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'settingID': settingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollSettings/clearCurrentPollPeriodAndSend', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollSettingsDeleteGet operation.
     * @callback module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorPollSettingsDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollSettingsDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling performanceIndicatorPollSettingsDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollSettings/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollSettingsEditPut operation.
     * @callback module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceIndicatorPollSettings} body 
     * @param {Integer} primaryKey 
     * @param {module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorPollSettingsEditPut = function(_4SAPIAppID, body, primaryKey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorPollSettingsEditPut";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling performanceIndicatorPollSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollSettingsLoadAllLightReportGet operation.
     * @callback module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsLoadAllLightReportGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorPollSettingsLightReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAllLightReport
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.batchesMaxCount  (default to 0)
     * @param {module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsLoadAllLightReportGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorPollSettingsLightReport>}
     */
    this.performanceIndicatorPollSettingsLoadAllLightReportGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollSettingsLoadAllLightReportGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchesMaxCount': opts['batchesMaxCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorPollSettingsLightReport];

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollSettings/loadAllLightReport', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollSettingsLoadSettingsByIDGet operation.
     * @callback module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsLoadSettingsByIDGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceIndicatorPollSettingsLightReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadSettingsByID
     * @param {String} _4SAPIAppID 
     * @param {Integer} settingID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.batchesMaxCount  (default to 0)
     * @param {module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsLoadSettingsByIDGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceIndicatorPollSettingsLightReport}
     */
    this.performanceIndicatorPollSettingsLoadSettingsByIDGet = function(_4SAPIAppID, settingID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollSettingsLoadSettingsByIDGet";
      }

      // verify the required parameter 'settingID' is set
      if (settingID == undefined || settingID == null) {
        throw "Missing the required parameter 'settingID' when calling performanceIndicatorPollSettingsLoadSettingsByIDGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'settingID': settingID,
        'batchesMaxCount': opts['batchesMaxCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceIndicatorPollSettingsLightReport;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollSettings/loadSettingsByID', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollSettingsLoadSettingsByIndicatorIDGet operation.
     * @callback module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsLoadSettingsByIndicatorIDGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceIndicatorPollSettingsLightReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadSettingsByIndicatorID
     * @param {String} _4SAPIAppID 
     * @param {Integer} indicatorID 
     * @param {module:api/PerformanceIndicatorPollSettingsApi~performanceIndicatorPollSettingsLoadSettingsByIndicatorIDGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceIndicatorPollSettingsLightReport}
     */
    this.performanceIndicatorPollSettingsLoadSettingsByIndicatorIDGet = function(_4SAPIAppID, indicatorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollSettingsLoadSettingsByIndicatorIDGet";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorPollSettingsLoadSettingsByIndicatorIDGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'indicatorID': indicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceIndicatorPollSettingsLightReport;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollSettings/loadSettingsByIndicatorID', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
